/**
 * ApplicationSelectorService
 * 
 * Created at 10 September 2018
 * Service responsible for selecting application and for keeping the applicationId in memory
 */
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';


import { tApplication, tDirectory } from './glowadminservices/glowadmin.typings';
import { GlowAdminService } from './glowadminservices/glowadmin.service';
import { tModeDirectoryApplication } from './app-config.typings';
import { UIConfigService } from './ui.service';
import { tApplicationDictionary } from './ui.typings';

@Injectable()
export class ApplicationSelectorService {

    private applications: tApplication[] = [];
    private applicationsDictionary: tApplicationDictionary;

    private selectedApplication: tApplication;
    private selectedDirectory: tDirectory;
    private modeObj: tModeDirectoryApplication;


    private AppsAnnouncer = new Subject<tApplication[]>();

    applications$ = this.AppsAnnouncer.asObservable();

    @Output() getSelectedApplication: EventEmitter<tApplication> = new EventEmitter();
    @Output() getSelectedApplicationDirectory: EventEmitter<tModeDirectoryApplication> = new EventEmitter();


    constructor(
        private glowAdminService: GlowAdminService,
        private uiConfigService: UIConfigService) {
        this.modeObj = this.uiConfigService.initialiseModeObj();
    };

    setApplicationDictionary(applicationList: tApplication[]) {
        this.applicationsDictionary = applicationList.reduce((acc, elem) => {
            return { ...acc, [elem.applicationId]: { name: elem.name, description: elem.description } };
        }, {})
        console.log("applicationsDictionary")
        console.log(this.applicationsDictionary)
    }

    getApplicationDictionary(): tApplicationDictionary {
        if (this.applicationsDictionary) {
            return this.applicationsDictionary
        } else {
            this.getApplications();
            return {}
        }
    }
    private announceApplications(): void {
        this.AppsAnnouncer.next(this.applications);
    };

    public getApplications(): void {

        this.glowAdminService
            .getInternalUserApplications()
            .subscribe(applications => {
                this.applications = applications;
                console.log(this.applications);
                this.announceApplications();
                this.setApplicationDictionary(this.applications);


            }, error => {
                console.log('User Organizations loading error is : ' + error);
            });
    };

    public selectDefaultApplication(): void {
        this.glowAdminService
            .getInternalUserApplications()
            .subscribe(applications => {

                if (applications && Array.isArray(applications) && applications.length > 0) {
                    this.applications = applications;
                    console.log(this.applications);
                    this.announceApplications();

                    // Set first application as default
                    this.setMode('application', applications[0], null);
                }

            }, error => {
                console.log('User Organizations loading error is : ' + error);
            });
    };

    public setApplication(selectedApp: tApplication) {
        console.log("setApplication")
        this.selectedApplication = selectedApp
        localStorage.setItem("application", JSON.stringify(this.selectedApplication))
        this.getSelectedApplication.emit(selectedApp);
    }

    public getApplication(): tApplication {
        return this.selectedApplication;

    }

    public getApplicationId(): string {
        let applicationId = null;
        if (this.modeObj && this.modeObj.mode === 'application' && this.modeObj.application) {
            applicationId = this.modeObj.application.applicationId
        }
        return applicationId
    }

    public getDirectoryId(): string {
        let directoryId = null;
        if (this.modeObj && this.modeObj.mode === 'directory' && this.modeObj.directory) {
            directoryId = this.modeObj.directory.directoryId
        }
        return directoryId
    }

    public getMode(): tModeDirectoryApplication {
        return this.modeObj
    }

    public setMode(mode: string, application: tApplication, directory: tDirectory) {
        localStorage.removeItem("mode")
        // localStorage.removeItem("application")
        // localStorage.removeItem("directory")
        this.modeObj = this.uiConfigService.initialiseModeObj();

        if (mode === 'application') {
            this.setApplication(application)
            this.modeObj.mode = mode
            this.modeObj.application = application

        } else if (mode === 'directory') {
            this.setDirectory(directory)
            this.modeObj.mode = mode
            this.modeObj.directory = directory
        } else {
            console.warn("MODE NOT RECOGNISED")
            console.warn(mode)
        }
        localStorage.setItem("mode", JSON.stringify(this.modeObj))
        this.getSelectedApplicationDirectory.emit(this.modeObj)
    }



    private setDirectory(selecetedDirectory: tDirectory) {
        console.log("setDirectory")
        this.selectedDirectory = selecetedDirectory
        localStorage.setItem("directory", JSON.stringify(this.selectedDirectory))
    }

};
